import { gql, useQuery } from '@apollo/client';
import { backendNameToLabel } from '../../../utils/formatting';

export const INSURED_SEARCH_BY_OPTIONS = gql`
  query InsuredSearchByOptions {
    insuredSearchByFields
  }
`;

export default function useInsuredSearchByOptions() {
  const { loading, error, data } = useQuery(INSURED_SEARCH_BY_OPTIONS, {
    onCompleted: () => {},
    onError: () => {}
  });

  return {
    insuredSearchByOptions:
      data?.insuredSearchByFields?.map(field => ({
        label: backendNameToLabel(field),
        value: field
      })) || [],
    loading,
    error
  };
}
